import { STATISTIC_BASE_PATH } from '@/config/baseModulesLink';
import { PROFILE_PATH } from '../Dashboard/DashboardLinks';

export const RANKING_PATH = 'ranking';
const base = `/${PROFILE_PATH}`;

export const STATISTIC_LINKS = {
  statistic: `${base}/${STATISTIC_BASE_PATH}`,
  ranking: `${base}/${STATISTIC_BASE_PATH}/${RANKING_PATH}`,
};
